import { render, staticRenderFns } from "./NewPendingInvoice.vue?vue&type=template&id=be165822&scoped=true&"
import script from "./NewPendingInvoice.vue?vue&type=script&lang=js&"
export * from "./NewPendingInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewPendingInvoice.vue?vue&type=style&index=0&id=be165822&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be165822",
  null
  
)

export default component.exports